import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  fetchFlashCardProgress,
  fetchFlashCards,
  markFlashCardRead,
  rewardFlashCardAd,
  resetFlashCardProgress,
  storeFlashCardView,
  toggleFlashCardBookmark,
} from "../services/flashCardService";

const keyFor = (scope) => ["flash-cards", scope];

export function useFlashCardProgress(params, enabled = true) {
  return useQuery({
    queryKey: [...keyFor("progress"), params],
    queryFn: () => fetchFlashCardProgress(params),
    enabled: enabled && Boolean(params?.states_id && params?.subject_id),
  });
}

export function useFlashCardDeck(params, enabled = true) {
  return useInfiniteQuery({
    queryKey: [...keyFor("deck"), params],
    queryFn: ({ pageParam = 1 }) => fetchFlashCards({ ...params, page: pageParam }),
    initialPageParam: 1,
    enabled: enabled && Boolean(params?.states_id && params?.subject_id),
    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.payload?.pagination || {};
      return Number(pagination.currentPage) < Number(pagination.totalPages)
        ? Number(pagination.currentPage) + 1
        : undefined;
    },
  });
}

export function useFlashCardActions() {
  const queryClient = useQueryClient();
  const refresh = () => queryClient.invalidateQueries({ queryKey: keyFor("progress") });

  return {
    markRead: useMutation({ mutationFn: markFlashCardRead, onSuccess: refresh }),
    bookmark: useMutation({ mutationFn: toggleFlashCardBookmark, onSuccess: refresh }),
    storeView: useMutation({ mutationFn: storeFlashCardView }),
    reset: useMutation({ mutationFn: resetFlashCardProgress, onSuccess: refresh }),
    rewardAd: useMutation({ mutationFn: rewardFlashCardAd }),
  };
}
